import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/type.machine.actions';
import * as actionsHome from '../../../../actions/process.home.actions';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';
import Machine from './Machine';

function sortData(arr, search) {
    if (!arr) {
        return arr;
    } else {
        const result = []
            .concat(arr)
            .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
            .reduce((arr, info) => {
                if (search && search.length > 0) {
                    const filter = search.filter(
                        (s) => info.nombre && info.nombre.toUpperCase().includes(s),
                    );
                    if (filter && filter.length > 0) {
                        arr.push(<Machine key={randomstring()} info={info} />);
                    }
                } else {
                    arr.push(<Machine key={randomstring()} info={info} />);
                }
                return arr;
            }, []);
        return result;
    }
}

class ListMachines extends React.Component {
    state = {
        index: 0,
        machines: sortData(this.props.machines, this.props.search),
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        console.log(nextProps.machines);
        this.setState({
            machines: sortData(nextProps.machines, nextProps.search),
        });
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { machines } = this.state;
        const { machines_is_loading, machines_has_errored } = this.props;

        if (machines_has_errored.hasErrored) {
            return (
                <Error open type={machines_has_errored.hasErrored}  message={machines_has_errored.error} handleClose={this.handleBack} />
            );
        } else if (machines === undefined) {
            return (
                <Error
                    open
                    message={<FormattedMessage id="error_machines_not_found" />}
                    handleClose={this.handleBack}
                />
            );
        } else {
            return (
                <div className={'flex_full_column  padding_top_12 height100'}>
                    {machines_is_loading && <Loading open opacity />}
                    <div
                        className="flex_full overflow_y_scroll padding_bottom_64"
                        onScroll={this.handleScroll}
                    >
                        {machines.map((u) => {
                            return u;
                        })}
                    </div>
                </div>
            );
        }
    }
}

ListMachines.propTypes = {
    machines: PropTypes.array.isRequired,
    machines_is_loading: PropTypes.bool.isRequired,
    machines_has_errored: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    return {
        machines: state.type_machines,
        machines_is_loading: state.type_machines_is_loading,
        machines_has_errored: state.type_machines_has_errored,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsHome), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(ListMachines));



// WEBPACK FOOTER //
// ./src/components/complex/inventory/machines/List.js